/* tslint:disable */
/* eslint-disable */
/**
 * mindd-payhub-server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InPersonPaymentCancelRequest } from '../model';
// @ts-ignore
import type { InPersonPaymentRequest } from '../model';
// @ts-ignore
import type { InvoiceDto } from '../model';
// @ts-ignore
import type { LastPaymentStatus } from '../model';
/**
 * InvoicePaymentApi - axios parameter creator
 * @export
 */
export const InvoicePaymentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 청구서 수동 결제 취소 (Y_ADMIN, Y_MANAGER)
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancel: async (invoiceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('cancel', 'invoiceId', invoiceId)
            const localVarPath = `/api/v1/invoices/{invoiceId}/payment/cancel`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 청구서 현장결제 취소 (영업사원 직접 환불, Y_ADMIN, Y_MANAGER)
         * @param {string} invoiceId 
         * @param {InPersonPaymentCancelRequest} inPersonPaymentCancelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelInPerson: async (invoiceId: string, inPersonPaymentCancelRequest: InPersonPaymentCancelRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('cancelInPerson', 'invoiceId', invoiceId)
            // verify required parameter 'inPersonPaymentCancelRequest' is not null or undefined
            assertParamExists('cancelInPerson', 'inPersonPaymentCancelRequest', inPersonPaymentCancelRequest)
            const localVarPath = `/api/v1/invoices/{invoiceId}/in-person-payment/cancel`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inPersonPaymentCancelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 가장 최근 청구서의 가장 최근 결제 상태 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastPaymentStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/invoices/last/payment-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 청구서 수동 결제 (Y_ADMIN, Y_MANAGER)
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pay: async (invoiceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('pay', 'invoiceId', invoiceId)
            const localVarPath = `/api/v1/invoices/{invoiceId}/payment`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 청구서 현장결제 (영업사원 직접 수금, Y_ADMIN, Y_MANAGER)
         * @param {string} invoiceId 
         * @param {InPersonPaymentRequest} inPersonPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payInPerson: async (invoiceId: string, inPersonPaymentRequest: InPersonPaymentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('payInPerson', 'invoiceId', invoiceId)
            // verify required parameter 'inPersonPaymentRequest' is not null or undefined
            assertParamExists('payInPerson', 'inPersonPaymentRequest', inPersonPaymentRequest)
            const localVarPath = `/api/v1/invoices/{invoiceId}/in-person-payment`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inPersonPaymentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvoicePaymentApi - functional programming interface
 * @export
 */
export const InvoicePaymentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvoicePaymentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 청구서 수동 결제 취소 (Y_ADMIN, Y_MANAGER)
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancel(invoiceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancel(invoiceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicePaymentApi.cancel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 청구서 현장결제 취소 (영업사원 직접 환불, Y_ADMIN, Y_MANAGER)
         * @param {string} invoiceId 
         * @param {InPersonPaymentCancelRequest} inPersonPaymentCancelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelInPerson(invoiceId: string, inPersonPaymentCancelRequest: InPersonPaymentCancelRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelInPerson(invoiceId, inPersonPaymentCancelRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicePaymentApi.cancelInPerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 가장 최근 청구서의 가장 최근 결제 상태 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLastPaymentStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LastPaymentStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLastPaymentStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicePaymentApi.getLastPaymentStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 청구서 수동 결제 (Y_ADMIN, Y_MANAGER)
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pay(invoiceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pay(invoiceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicePaymentApi.pay']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 청구서 현장결제 (영업사원 직접 수금, Y_ADMIN, Y_MANAGER)
         * @param {string} invoiceId 
         * @param {InPersonPaymentRequest} inPersonPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async payInPerson(invoiceId: string, inPersonPaymentRequest: InPersonPaymentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.payInPerson(invoiceId, inPersonPaymentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicePaymentApi.payInPerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InvoicePaymentApi - factory interface
 * @export
 */
export const InvoicePaymentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvoicePaymentApiFp(configuration)
    return {
        /**
         * 
         * @summary 청구서 수동 결제 취소 (Y_ADMIN, Y_MANAGER)
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancel(invoiceId: string, options?: any): AxiosPromise<InvoiceDto> {
            return localVarFp.cancel(invoiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 청구서 현장결제 취소 (영업사원 직접 환불, Y_ADMIN, Y_MANAGER)
         * @param {string} invoiceId 
         * @param {InPersonPaymentCancelRequest} inPersonPaymentCancelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelInPerson(invoiceId: string, inPersonPaymentCancelRequest: InPersonPaymentCancelRequest, options?: any): AxiosPromise<InvoiceDto> {
            return localVarFp.cancelInPerson(invoiceId, inPersonPaymentCancelRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 가장 최근 청구서의 가장 최근 결제 상태 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastPaymentStatus(options?: any): AxiosPromise<LastPaymentStatus> {
            return localVarFp.getLastPaymentStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 청구서 수동 결제 (Y_ADMIN, Y_MANAGER)
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pay(invoiceId: string, options?: any): AxiosPromise<InvoiceDto> {
            return localVarFp.pay(invoiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 청구서 현장결제 (영업사원 직접 수금, Y_ADMIN, Y_MANAGER)
         * @param {string} invoiceId 
         * @param {InPersonPaymentRequest} inPersonPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payInPerson(invoiceId: string, inPersonPaymentRequest: InPersonPaymentRequest, options?: any): AxiosPromise<InvoiceDto> {
            return localVarFp.payInPerson(invoiceId, inPersonPaymentRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvoicePaymentApi - object-oriented interface
 * @export
 * @class InvoicePaymentApi
 * @extends {BaseAPI}
 */
export class InvoicePaymentApi extends BaseAPI {
    /**
     * 
     * @summary 청구서 수동 결제 취소 (Y_ADMIN, Y_MANAGER)
     * @param {string} invoiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicePaymentApi
     */
    public cancel(invoiceId: string, options?: RawAxiosRequestConfig) {
        return InvoicePaymentApiFp(this.configuration).cancel(invoiceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 청구서 현장결제 취소 (영업사원 직접 환불, Y_ADMIN, Y_MANAGER)
     * @param {string} invoiceId 
     * @param {InPersonPaymentCancelRequest} inPersonPaymentCancelRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicePaymentApi
     */
    public cancelInPerson(invoiceId: string, inPersonPaymentCancelRequest: InPersonPaymentCancelRequest, options?: RawAxiosRequestConfig) {
        return InvoicePaymentApiFp(this.configuration).cancelInPerson(invoiceId, inPersonPaymentCancelRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 가장 최근 청구서의 가장 최근 결제 상태 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicePaymentApi
     */
    public getLastPaymentStatus(options?: RawAxiosRequestConfig) {
        return InvoicePaymentApiFp(this.configuration).getLastPaymentStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 청구서 수동 결제 (Y_ADMIN, Y_MANAGER)
     * @param {string} invoiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicePaymentApi
     */
    public pay(invoiceId: string, options?: RawAxiosRequestConfig) {
        return InvoicePaymentApiFp(this.configuration).pay(invoiceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 청구서 현장결제 (영업사원 직접 수금, Y_ADMIN, Y_MANAGER)
     * @param {string} invoiceId 
     * @param {InPersonPaymentRequest} inPersonPaymentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicePaymentApi
     */
    public payInPerson(invoiceId: string, inPersonPaymentRequest: InPersonPaymentRequest, options?: RawAxiosRequestConfig) {
        return InvoicePaymentApiFp(this.configuration).payInPerson(invoiceId, inPersonPaymentRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

